window.addEventListener('DOMContentLoaded', function () {
  const DOMModalTriggers = document.querySelectorAll('.open-modal');
  const DOMModal = document.querySelector('.modal');
  const DOMModalContent = DOMModal.querySelector('.modal-content');
  const DOMModalPDF = DOMModal.querySelector('.modal-pdf__wrapper');
  const DOMModalImg = DOMModal.querySelector('.modal-img__wrapper');
  const DOMModalClose = DOMModal.querySelector('.modal-close');
  const pdfEventBus = new pdfjsViewer.EventBus();
  const pdfViewer = new pdfjsViewer.PDFViewer({
    container: DOMModalPDF,
    eventBus: pdfEventBus
  });
  /**
   * @function isMobile
   * @description Returns if site is mobile by checking if menu hamburger is visible
   */
  const isMobile = (function() {
    var DOMTarget = document.querySelector('.site-header .mr-5');
    return function() {
      return getComputedStyle(DOMTarget).display === 'block';
    }
  })();

  /**
   * @function closeModal
   * @description "Closes" modal and hides content
   * @param e Event info
   */
  function closeModal(e) {
    e.preventDefault();
    DOMModal.classList.remove('active');
    DOMModalContent.classList.remove('active');
    resetModal();
  }

  /**
   * @function resetModal
   * @description Hides modal content (in preparation to display other or new content)
   */
  function resetModal() {
    DOMModalPDF.classList.remove('modal-pdf__wrapper--active');
    DOMModalImg.classList.remove('modal-image__wrapper--active')
  }

  // PDF Load handling
  pdfEventBus.on("pagesinit", function () {
    DOMModalContent.classList.add('active');
    DOMModalPDF.classList.add('modal-pdf__wrapper--active');

    pdfViewer.currentScaleValue = "page-width";
    DOMModalContent.scrollTop = 0;
  });

  // Image load handling
  DOMModalImg.querySelector('img').addEventListener('load', function () {
    DOMModalContent.classList.add('active');
    DOMModalImg.classList.add('modal-img__wrapper--active')
  })

  // Modal trigger handling
  DOMModalTriggers.forEach(DOMModalTrigger => {
    DOMModalTrigger.addEventListener('click', function (e) {
      const asset = DOMModalTrigger.pathname;
      let supportedAsset = false;

      if (!asset) {
        return;
      }

      if (isMobile()) {
        return;
      }

      e.preventDefault();

      resetModal();

      // PDF
      if (/\.pdf$/i.test(asset)) {
        pdfjsLib.getDocument(DOMModalTrigger.href).promise.then(function (pdf) {
          pdfViewer.setDocument(pdf);
        }).catch(function (e) {
          console.log('FAILED: ', e);
        });
        supportedAsset = true;
      // Image
      } else if (/\.(apng|avif|gif|jpe?g|png|svg|webp)/i.test(asset)) {
        DOMModalImg.querySelector('img').src = DOMModalTrigger.href;
        supportedAsset = true;
      }

      if (supportedAsset) {
        DOMModal.classList.add('active');
      }
    });
  });

  // Prevent close when clicking on content
  DOMModalContent.addEventListener('click', function (e) {
    e.stopPropagation();
  });

  // Modal close handling
  DOMModal.addEventListener('click', closeModal);
  DOMModalClose.addEventListener('click', closeModal);
  window.addEventListener('keyup', (e) => {
    if (e.code == 'Escape') {
      closeModal(e);
    }
  });
});